import { apiClientV2 } from '@/services/rest-api/apiClient'
let baseURL = process.env.VUE_APP_REST_API_VSMS
baseURL = baseURL[baseURL.length] === '/' ? baseURL.slice(0, -1) : baseURL

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters?.length > 0 ? 
      [`position.name eq 'Driver'`, ...queryParam.filters] : 
      `position.name eq 'Driver'`,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/user',
    params: params,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/user`,
    params: {
      filters: `id eq ${id}`,
    },
  })

  return response?.data
}
